<template>
  <Modal @close="close">
    <div slot="modal-header">
      {{ $t(config.get('translationKey')) }}
    </div>

    <div class="d-flex flex-column justify-content-center align-items-center">
      <el-input v-model="value" />
    </div>
    <div slot="modal-footer">
      <el-button @click="close">
        {{ $t('general.close') }}
      </el-button>
      <el-button :disabled="updateButtonDisabled" type="primary" @click="updateConfig">
        {{ $t('general.update') }}
      </el-button>
    </div>
  </Modal>
</template>

<script>
import Modal from '../atoms/Modal';
import { EventBus } from '../../event-bus.js';
export default {
  name: 'ConfigEditModal',
  components: { Modal },
  props: {
    config: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.value = this.config.get('value');
  },
  destroyed() {},
  data() {
    return {
      value: '',
    };
  },
  computed: {
    updateButtonDisabled() {
      return this.config.get('value') === this.value;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async updateConfig() {
      this.config.set('value', this.value);
      await this.config.save();
      EventBus.$emit('AdminConfigUpdated');
      this.$message.info(this.$t('messages.success_config_update'));
      this.close();
    },
  },
};
</script>

<style scoped></style>
